import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';

@Component({
  selector: 'app-change-language-dropdown',
  templateUrl: './change-language-dropdown.html',
  styleUrls: ['./change-language-dropdown.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, TranslateModule, DropdownModule]
})
export class ChangeLanguageDropdown {
  readonly languages = input.required<string[]>();
  readonly currentLanguage = input.required<string>();

  readonly changeLanguageEvent = output<string>();

  protected onChangeLanguage(event: DropdownChangeEvent): void {
    this.changeLanguageEvent.emit(event.value);
  }
}
